<template>
  <div class="modal filter" :class="{ active: showModal }">
    <div class="container modal-top">
      <div class="modal-top__back-Link" @click="$emit('modal', 'filter')">
        <BackIcon />
      </div>
      <div class="modal-top__wrap">
        <div class="modal-top__title">Фильтры</div>
      </div>
    </div>
    <div class="container filter-container">
      <div class="filter-item">
        <div class="filter-item__title">Категория</div>
        <div class="filter-item__list">
          <label
            class="filter-item__label"
            v-for="category in categories"
            :key="category.id"
          >
            <input
              type="checkbox"
              :value="category.id"
              v-model="selectedCategories"
            />
            <span>{{ category.name }}</span>
          </label>
        </div>
      </div>
      <div class="filter-item">
        <div class="filter-item__title">Автор</div>
        <div class="filter-item__list">
          <label
            class="filter-item__label"
            v-for="author in authors"
            :key="author.id"
          >
            <input
              type="checkbox"
              :value="author.id"
              v-model="selectedAuthors"
            />
            <span>{{ author.name }}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="filter-buttons">
      <ButtonEl @click="applyFilter">Применить</ButtonEl>
      <ButtonEl @click="clearFilter" variant="white">Сбросить</ButtonEl>
    </div>
  </div>
</template>

<script>
import BackIcon from '@/components/icons/BackIcon.vue';
import ButtonEl from '@/components/blocks/buttons/ButtonEl.vue';
import { getCategoriesFilter, getAuthorsFilter } from '@/functions/API';

export default {
  name: 'FilterModal',
  components: {
    BackIcon,
    ButtonEl,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    authorsFromGet: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showModal: false,
      categories: [],
      authors: [],
      selectedCategories: [],
      selectedAuthors: [],
    };
  },
  mounted() {
    this.showModal = this.show;
    this.getFilters();
    if (this.authorsFromGet.length > 0) {
      this.authorsFromGet.map((author) => {
        this.selectedAuthors.push(author);
      });
    }
  },
  watch: {
    show() {
      this.showModal = this.show;
    },
    '$route.query': {
      immediate: true,
      handler(newQuery) {
        if (newQuery.author_id && newQuery.author_name) {
          this.selectedAuthors.push(newQuery.author_id);
        }
      },
    },
  },
  methods: {
    getFilters() {
      getCategoriesFilter((response) => {
        if (response !== false) {
          if (response?.length > 0) {
            this.categories = response;
          }
        }
      });
      getAuthorsFilter((response) => {
        if (response !== false) {
          if (response?.length > 0) {
            this.authors = response;
          }
        }
      });
    },
    applyFilter() {
      const data = JSON.parse(
        JSON.stringify({
          categories: this.selectedCategories,
          authors: this.selectedAuthors,
        }),
      );
      this.$emit('filter', data);
    },
    clearFilter() {
      this.selectedCategories = [];
      this.selectedAuthors = [];
      this.applyFilter();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  &-top {
    position: relative;
    background-color: var(--color-white);
    color: var(--color-black);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    position: relative;
    display: flex;
    padding-top: 16px;
    padding-bottom: 16px;
    &__wrap {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      min-height: 40px;
    }
    &__back-Link {
      color: var(--color-blue);
      cursor: pointer;
      svg {
        width: 20px;
        height: 20px;
        min-width: 20px;
        min-height: 20px;
      }
    }
    &__title {
      color: var(--color-black);
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 125%;
    }
  }
}
.filter {
  position: fixed;
  left: 0;
  top: -120%;
  height: 100%;
  width: 100%;
  background-color: var(--color-white);
  transition: 0.3s ease-in-out;
  &.active {
    top: 0;
  }
  &-container {
    display: flex;
    flex-direction: column;
    gap: 32px;
    margin-top: 16px;
    margin-bottom: 16px;
    height: calc(100% - 244px);
    overflow-y: auto;
  }
  &-item {
    display: flex;
    flex-direction: column;
    gap: 12px;
    &__title {
      color: var(--color-black);
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 125%;
    }
    &__list {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
    &__label {
      display: flex;
      align-items: center;
      gap: 12px;
      cursor: pointer;
      input {
        appearance: none;
        width: 20px;
        height: 20px;
        min-width: 20px;
        min-height: 20px;
        border-radius: 4px;
        background-color: var(--color-gray-middle);
        cursor: pointer;
        transition: 0.3s ease-in-out;
        margin: 0;
        &:checked {
          background-color: var(--color-blue);
          border-color: var(--color-blue);
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e");
        }
        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
          & + span {
            opacity: 0.5;
            cursor: not-allowed;
          }
        }
      }
      span {
        color: var(--color-black);
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 125%;
      }
    }
  }
  &-buttons {
    position: absolute;
    bottom: 16px;
    left: 50%;
    width: calc(100% - 32px);
    max-width: calc(600px - 32px);
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
}
</style>
